import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const SEGGNA_WHATSAPP_DOCUMENT_VIDEO_LIMIT_MB = 100;

export const getSeggnaWhatsappVideoUploadLimit = ({
  inbox,
  mime,
  installationLimit,
}) => {
  const isWhatsappCloudVideo =
    inbox?.channel_type === INBOX_TYPES.WHATSAPP &&
    inbox?.provider === 'whatsapp_cloud' &&
    mime?.startsWith('video/');

  if (!isWhatsappCloudVideo) return null;

  return Math.min(SEGGNA_WHATSAPP_DOCUMENT_VIDEO_LIMIT_MB, installationLimit);
};
